import { useSelector } from 'react-redux';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import { DefermentSlideOut, dealLockHooks, useCashDownField, useDeferredDownPaymentSlideOut } from '@makemydeal/dr-dash-components';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import {
    DeferredAmount,
    LabelSeparator,
    LabelWithAction,
    OutOfFlowHost,
    SmallAction,
    StackedValue
} from '../../../ScenarioGrid.style';
import { RowLabelAction } from '../../RowLabelAction';
import { ScenarioRow } from '../../ScenarioRow';

export const DEFERMENT = 'Deferment';

export const CashDownDefermentRow = () => {
    const theme = useInterstateTheme();
    const { label, inputProps } = useCashDownField();
    const { isSlideOutOpen, toggleSlideOut, slideOutProps } = useDeferredDownPaymentSlideOut();
    const deferredTotalAmount = useSelector(offerReduxSelectors.getDeferredDownPayment)?.amount;
    const isLocked = dealLockHooks.useIsDealLocked();
    const inputId = useScenarioCellId('cashDown');

    return (
        <ScenarioRow
            rowKey="cashDown"
            label={
                <LabelWithAction theme={theme}>
                    <label htmlFor={inputId} data-testid="cash-down-label">
                        {label}
                    </label>
                    <LabelSeparator theme={theme} aria-hidden />
                    <RowLabelAction onActivate={toggleSlideOut} disabled={isLocked} testId="deferment-action">
                        <SmallAction>{DEFERMENT}</SmallAction>
                    </RowLabelAction>
                </LabelWithAction>
            }
        >
            <StackedValue>
                <NumericInput {...inputProps} id={inputId} displayLabel={false} />
                {deferredTotalAmount !== undefined && deferredTotalAmount > 0 && (
                    <DeferredAmount theme={theme} data-testid="deferred-amount-label">
                        Deferred: {formatDollarsAndCents(deferredTotalAmount)}
                    </DeferredAmount>
                )}
            </StackedValue>
            {isSlideOutOpen && (
                <OutOfFlowHost>
                    <DefermentSlideOut {...slideOutProps} />
                </OutOfFlowHost>
            )}
        </ScenarioRow>
    );
};
